import React, { useRef, useState, useEffect } from 'react';
import { Typography, Paper, TextField, Box, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';

const STORAGE_KEY = 'companyDetails';

function CompanyDetailsPage() {
  const [form, setForm] = useState({
    companyName: '',
    companyAddress: '',
    providerId: '',
    mobile: '',
    email: ''
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Load from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      setForm(JSON.parse(saved));
    }
  }, []);

  // Refs for each field
  const refs = {
    companyName: useRef(),
    companyAddress: useRef(),
    providerId: useRef(),
    mobile: useRef(),
    email: useRef(),
  };
  const fieldOrder = ['companyName', 'companyAddress', 'providerId', 'mobile', 'email'];

  const handleChange = (e) => {
    const newForm = { ...form, [e.target.name]: e.target.value };
    setForm(newForm);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newForm));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSnackbar({ open: true, message: 'Company details updated!', severity: 'success' });
      // Move to next field
      const idx = fieldOrder.indexOf(e.target.name);
      if (idx !== -1 && idx < fieldOrder.length - 1) {
        refs[fieldOrder[idx + 1]].current.focus();
      } else {
        e.target.blur();
      }
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h5" fontWeight={700} mb={2}>Company Details</Typography>
      <Box display="flex" flexDirection="column" gap={2}>
        <TextField
          label="Company Name"
          name="companyName"
          value={form.companyName}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          inputRef={refs.companyName}
          fullWidth
        />
        <TextField
          label="Company Address"
          name="companyAddress"
          value={form.companyAddress}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          inputRef={refs.companyAddress}
          fullWidth
          multiline
          minRows={2}
        />
        <TextField
          label="Provider ID"
          name="providerId"
          value={form.providerId}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          inputRef={refs.providerId}
          fullWidth
        />
        <TextField
          label="Mobile Number"
          name="mobile"
          value={form.mobile}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          inputRef={refs.mobile}
          fullWidth
        />
        <TextField
          label="Email"
          name="email"
          value={form.email}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          inputRef={refs.email}
          fullWidth
        />
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbar.severity} elevation={6} variant="filled" sx={{ fontSize: 16, fontWeight: 600, borderRadius: 2 }}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </Paper>
  );
}

export default CompanyDetailsPage; 